import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f77100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center mb-[24px]" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-[141px]" }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-[4px] mr-[4px] text-Text/text_medium text-[12px]" }, "Or"),
  /*#__PURE__*/_createElementVNode("hr", { class: "w-[141px]" })
], -1))
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-Text/text_info font-gordita-medium text-[15px] pr-[60px] italic font-bold" }, "Login with Azure AD", -1))

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';
import azureLogo from '@/assets/images/login/azure_logo.svg';
import { useAzure } from '@/views/login/loginComponents/azure/azure.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'azureLogin',
  props: {
    isConnected: { type: Boolean }
  },
  setup(__props: any) {



const { handleAzureLogin } = useAzure();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(IncrediButton), {
          class: _normalizeClass(["border-System/app_border cursor-pointer border-[0.5px] hover:bg-Hovers/hover_info", { 'disabled-button': !__props.isConnected }]),
          style: {"border-radius":"50px","height":"40px"},
          design: "ghost-grey",
          size: "big",
          type: "submit",
          onKeydown: _withKeys(_withModifiers(_unref(handleAzureLogin), ["prevent"]), ["enter"]),
          onClick: _withModifiers(_unref(handleAzureLogin), ["stop","prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _unref(azureLogo),
                class: "mr-[48px]"
              }, null, 8, _hoisted_4),
              _hoisted_5
            ])
          ]),
          _: 1
        }, 8, ["class", "onKeydown", "onClick"])
      ])
    ]),
    _: 1
  }))
}
}

})